<template>
  <span class="card-marks" role="img" aria-label="Accepted cards">
    <!-- Visa -->
    <svg v-if="has('visa')" viewBox="0 0 48 32" class="cm" aria-label="Visa">
      <rect width="48" height="32" rx="4" fill="#fff" stroke="#e6e6e6" />
      <text x="24" y="21" text-anchor="middle" font-family="Arial, sans-serif" font-size="12.5"
            font-weight="700" font-style="italic" letter-spacing="0.5" fill="#1A1F71">VISA</text>
    </svg>

    <!-- Mastercard -->
    <svg v-if="has('mastercard')" viewBox="0 0 48 32" class="cm" aria-label="Mastercard">
      <rect width="48" height="32" rx="4" fill="#fff" stroke="#e6e6e6" />
      <circle cx="20" cy="16" r="9" fill="#EB001B" />
      <circle cx="28" cy="16" r="9" fill="#F79E1B" />
      <path d="M24 9.4a9 9 0 0 1 0 13.2 9 9 0 0 1 0-13.2z" fill="#FF5F00" />
    </svg>

    <!-- American Express -->
    <svg v-if="has('amex')" viewBox="0 0 48 32" class="cm" aria-label="American Express">
      <rect width="48" height="32" rx="4" fill="#2E77BC" />
      <text x="24" y="20" text-anchor="middle" font-family="Arial, sans-serif" font-size="7.5"
            font-weight="700" fill="#fff" letter-spacing="0.3">AMEX</text>
    </svg>
  </span>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { company } from "@/config/company";

export default defineComponent({
  name: "CardMarks",
  setup() {
    const schemes = company.payments.schemes;
    const has = (s: string) => (schemes as string[]).includes(s);
    return { has };
  },
});
</script>

<style scoped>
.card-marks {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.cm {
  width: 42px;
  height: 28px;
  display: inline-block;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.15));
}
</style>
